<template>
  <div class="wrapper">
    <i class="rotate iconfont icon-bofang1" @click="Autorotate" v-if="isShowRotate"></i>
    <i class="rotate iconfont icon-iconfont32" @click="Autorotate" v-else></i>
    <i
      class="deviceOrientation iconfont icon-zhongliganyingcopy"
      @click="DeviceOrientation"
      v-if="!isDeviceOrientation"
    ></i>
    <i
      class="deviceOrientation iconfont icon-zhongliganying-guan"
      @click="DeviceOrientation"
      v-else
    ></i>
    <i class="stereoView iconfont icon-vr" @click="StereoView" v-if="!isStereoView"></i>
    <i class="stereoView iconfont icon-vr1" @click="StereoView" v-else></i>
    <div id="viewer"></div>
  </div>
</template>

<script>
const THREE = (window.THREE = require("three"));
require("three/examples/js/controls/DeviceOrientationControls");
require("three/examples/js/effects/StereoEffect");
import PhotoSphereViewer from "photo-sphere-viewer";
export default {
  name: "preview",

  props: {
    url: String,
    markers: Array
  },

  data() {
    return {
      progress: 0,
      isShow: true,
      viewer: null,
      isShowRotate: false,
      isDeviceOrientation: false,
      isStereoView: false
    };
  },

  created() {
    this.$nextTick(() => {
      this._photoShereViewer();
    });
  },

  methods: {
    _photoShereViewer() {
      this.viewer = new PhotoSphereViewer({
        container: "viewer",
        panorama: this.url,
        navbar: false,
        gyroscope: true,
        size: {
          width: "100%",
          height: "100%"
        },
        min_fov: 90,
        max_fov: 115,
        markers: this.markers
      });
      let that = this;
      this.viewer.on("select-marker", function(marker) {
        that.$emit("clickMarker", marker);
      });
    },

    Autorotate() {
      this.isShowRotate = !this.isShowRotate;
      if (this.isShowRotate) {
        this.viewer.startAutorotate();
      } else {
        this.viewer.stopAutorotate();
      }
    },

    DeviceOrientation() {
      this.isDeviceOrientation = !this.isDeviceOrientation;
      if (this.isDeviceOrientation) {
        this.viewer.startGyroscopeControl();
      } else {
        this.viewer.stopGyroscopeControl();
      }
    },

    StereoView() {
      this.isStereoView = !this.isStereoView
      if (this.isStereoView) {
        this.viewer.startStereoView();
      } else {
        this.viewer.stopStereoView();
      }
    }
  }
};
</script>

<style lang="less" scope>
.wrapper {
  position: relative;
  height: 100%;
  .rotate {
    position: absolute;
    right: 10px;
    top: 60px;
    z-index: 999;
    font-size: 20px;
  }
  .deviceOrientation {
    position: absolute;
    right: 10px;
    top: 110px;
    z-index: 999;
    font-size: 20px;
  }
  .stereoView {
    position: absolute;
    right: 10px;
    top: 160px;
    z-index: 999;
    font-size: 20px;
  }
  #viewer {
    width: 100%;
    height: 100%;
  }
}
</style>
